export const tabs = [
  { title: "Task Planning", value: "task-planning" },
];

export const editTabs = [
  // { title: "Actual Task", value: "actual-task" },
  { title: "Notes", value: "notes" },
  { title: "Attachments", value: "attachments" }
]

export const extraTabs = [
  // { title: "", value: "actual-task" },
  { title: "", value: "notes" },
  { title: "", value: "attachments" }
]

export const safetyCheckTab = [{ title: "Safety Compliment Form", value: "safety-form" }]
export const qualityCheckTab = [{ title: "Quality Control Check", value: "quality-check" }]

export const taskPlanningTabs = [
  { title: "General", value: "general" },
  { title: "Dependency", value: "dependency" },
];

export const roleName = {
  "project manager": "PM",
  "site manager": "SM",
  "quality officer": "QC",
  "safety officer": "SC"
};